<template>
  <div class="kpi_table--column">
    <div class="kpi_table--column--heading">
      <p>Goal</p>
    </div>

    <template v-for="(row, key) in kpiRowInfo">
      <stats-kpi-cell-goal
        v-if="doesUserHaveAccess(row.permissionCheck)"
        :id="key"
        :key="key"
      />
    </template>
  </div>
</template>

<script>
import StatsKpiCellGoal from "./StatsKpiCellGoal";

export default {
  name: "StatsKpiColumnGoal",
  components: {StatsKpiCellGoal},
  computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
    kpiRowInfo() {
      return this.$store.getters["statsKpi/kpiRowInfo"];
    },
  },
  methods: {
    doesUserHaveAccess(rowPermissionCheck) {
      // If rowPermissionCheck is null then show row
      if (!rowPermissionCheck) return true;
      // If owner show all row
      if (this.authUser.is_owner) return true;
      // check if user has rowPermissionCheck
      return this.authUser[rowPermissionCheck];
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.kpi_table--column {
  flex: 0 0 $kpiColumnSkinny;

  &--cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: $grey-50;
    text-align: center;

    &--amount {
      margin: 0 10px;
    }
  }
}
</style>
